import React from "react";
import { useNavigate } from "react-router-dom";
import "./Bidcom.css";
const Enoughamount = ({ setopen }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main-choice-div-recharge">
        <div className="center-error">
          <p> Error message</p>
          <h2>Not enouhg points</h2>
          <button
            onClick={() => {
              navigate("/recharge");
              setopen(false);
            }}
          >
            Recharge now
          </button>
        </div>
      </div>
    </>
  );
};

export default Enoughamount;
